import React from 'react';
import { DesktopWarningModal } from './desktop-warning-modal.component';
export const SessionPrompts = () => {
  return <>
      <DesktopWarningModal />
    </>;
};